import React from 'react';
import styled from 'styled-components'
import { useNavigate } from 'react-router-dom';
import { MediumIcon } from '../../shared/component/IconBody';
import logo from '../../asset/gnb/logo_small.png';



export interface LeftLogoUsernameProps {
  isHovered: boolean;
}

const AdminLnbLogoUsername: React.FC<LeftLogoUsernameProps> = ({ isHovered }) => {
  const navigate = useNavigate();

  const handleLogoClick = () => {
    navigate(`/`);
  }

  return (
    <LnbLogoUsernameComp $isHovered={isHovered}>
      <StyledLink onClick={handleLogoClick}>
        <MediumIcon src={logo} alt='toggle menu icon' />
      </StyledLink>
      <Username>
        Architrave Admin
      </Username>
    </LnbLogoUsernameComp>
  )
}

const LnbLogoUsernameComp = styled.section<{ $isHovered: boolean }>`
  width: ${({ $isHovered }) => $isHovered ? 'clamp(150px, 20vw, 210px)' : '0vw'};
  height: 7.5vh;
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 0.5vw clamp(12px, 1.2vw, 1.2vw);
  overflow: hidden;
  transition: width 0.6s ease-in-out;
  margin-bottom: 6vh;
`;

const Username = styled.div`
  overflow: hidden;
  white-space: nowrap;
  text-decoration: none;
  text-overflow: ellipsis;
  &:hover {
    text-decoration: ${({ theme }) => theme.fontWeight.decoration};
  }
  ${({ theme }) => theme.typography.Body_03_1};
  pointer-events: auto;
`;

const StyledLink = styled.div`
  padding-top: 2px;
  cursor: pointer;
  &:hover {
    transform: scale(1.08);
  }
  transition: transform 0.3s ease-in-out;
`;

export default AdminLnbLogoUsername;
